import { showAlert } from '../zeta-widget/tools/alert-tool';
import { checkRequiredProperty, isEmail } from "crk-lib-tool";

const { MINIMUM_PASSWORD_LENGTH, RUN_MODE } = require('../configs/constant.json');
const MESSAGES = require('../configs/msg-th.json');

export function validate(data, setLabelMessage) {
  checkRequiredProperty(data, ['email', 'fullname', 'password', 'captcha'], (err) => {
    if (err) {
      const _msg = {};
      _msg.text = 'กรุณาป้อนข้อมูลให้ครบทุกช่อง';
      _msg.classes = 'text-danger';

      setLabelMessage(_msg);

      showAlert(err.replace(/\n/g, '<br />\n'));
      return false;
    }
  })

  if (!RUN_MODE || RUN_MODE==='production') {
    if (!isEmail(data.email)) {
      const _msg = {};
      _msg.text = 'ป้อน email ไม่ถูกต้อง';
      _msg.classes = 'text-danger';
  
      setLabelMessage(_msg);
      return false;
    }
  }

  if (data.password.trim().length < MINIMUM_PASSWORD_LENGTH) {
    const _msg = {};
    _msg.text = 'รหัสผ่าน ต้องไม่น้อยกว่า ' + MINIMUM_PASSWORD_LENGTH + ' ตัวอักษร';
    _msg.classes = 'text-danger';

    setLabelMessage(_msg);
    showAlert(_msg);
    return false;
  }

  if (data.password !== data.repeat) {
    const _msg = {};
    _msg.text = 'กรุณาใส่รหัสผ่านให้ตรงกัน ทั้ง 2 ช่อง';
    _msg.classes = 'text-danger';

    setLabelMessage(_msg);
    showAlert(_msg);
    return false;
  }

  return true;
}

export function translateErrorMessage(msg) {
  if (msg.match(/already regis/i)) {
    return MESSAGES.EMAIL_ALREADY_REGISTERED;
  }

  return msg;
}